import {Component} from '@angular/core';

@Component({
    selector: 'tfl-refund-transfer-icon',
    template: require('./refund.html')
})
export class RefundTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/refund/refund.transfer.icon.ts